import { render, staticRenderFns } from "./SegmentoEmpresaField.vue?vue&type=template&id=f9bd3040&scoped=true&"
import script from "./SegmentoEmpresaField.vue?vue&type=script&lang=js&"
export * from "./SegmentoEmpresaField.vue?vue&type=script&lang=js&"
import style0 from "./SegmentoEmpresaField.vue?vue&type=style&index=0&id=f9bd3040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bd3040",
  null
  
)

export default component.exports